// frontend/src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/home/HomePage.vue'
import LoginPage from '../views/login/LoginPage.vue'
import About from '../views/AboutPage.vue'
import NotFoundPage from '../views/NotFoundPage.vue'
import { getToken } from '../api/apiClient'
import SessionPage from '../views/session/SessionPage.vue'
import ForgotPasswordPage from '../views/login/ForgotPasswordPage.vue'
import ResetPasswordPage from '../views/login/ResetPasswordPage.vue'
import selectPage from '../views/select/SelectPage.vue'
import NoticeList from '../views/notice/NoticeList.vue'
import VmdReq from '../views/vmd/VmdReq.vue'
import VmdSubmissions from '../views/vmd/VmdSubmissions.vue'
import InquiryList from '../views/inquiry/InquiryList.vue'
import WebhardDownload from '@/views/webhard/WebhardDownload.vue'
import TaxLogin from '@/views/tax/TaxLogin.vue'
import TaxView from '@/views/tax/TaxView.vue'
import TestPage from '@/views/testView.vue'
import ProfilePage from '../views/profile/ProfilePage.vue'
import ResumeAdd from '../views/profile/ResumeAdd.vue'

const routes = [
  { path: '/', name: 'Home', component: HomePage }, // 임시로 주석 처리
  // { path: '/home', name: 'Home', component: HomePage },
  // { path: '/', redirect: '/select' }, // 임시로 홈 페이지를 select로 리다이렉트
  { path: '/login', name: 'Login', component: LoginPage },
  { path: '/about', name: 'About', component: About },
  { path: '/profile', name: 'Profile', component: ProfilePage },
  { path: '/resume/new', name: 'ResumeAdd', component: ResumeAdd },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFoundPage },
  { path: '/session', name: 'Session', component: SessionPage },
  { path: '/notice', name: 'Notice', component: NoticeList },
  { path: '/inquiry', name: 'Inquiry', component: InquiryList },
  { path: '/vmd/requests', name: 'VmdRequests', component: VmdReq },
  {
    path: '/vmd/submissions',
    name: 'VmdSubmissions',
    component: VmdSubmissions,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordPage,
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPasswordPage,
    props: route => ({
      branchCode: route.query.branchCode,
      verified: route.query.verified === 'true',
      token: route.query.token,
    }),
  },
  { path: '/select', name: 'Select', component: selectPage },
  {
    path: '/webhard-download',
    name: 'WebhardDownload',
    component: WebhardDownload,
    meta: {
      title: '상품이미지 다운로드',
    },
  },
  {
    path: '/tax-login',
    name: 'tax_login',
    component: TaxLogin,
    meta: {
      title: '세금계산서 로그인',
    },
  },
  {
    path: '/tax-view/:bus_no',
    name: 'tax_view',
    component: TaxView,
    meta: {
      title: '세금계산서 조회',
    },
  },
  {
    path: '/test',
    name: 'test',
    component: TestPage,
    meta: {
      title: '세금계산서 테스트',
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 페이지 이동 시 스크롤 위치 초기화
    return savedPosition || { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!getToken()
  const publicPages = ['Login', 'ForgotPassword', 'ResetPassword']
  const requiresAuth = !publicPages.includes(to.name)

  if (requiresAuth && !isAuthenticated) {
    // 강제로 로그인 페이지로 리다이렉트
    window.location.href = '/login'
    return
  }
  // 이미 인증된 사용자가 로그인 페이지 접근 시 홈 페이지로 리다이렉트
  if (isAuthenticated && to.name === 'Login') {
    next({ path: '/' }) // 홈 페이지로 리다이렉트
    return
  }

  // 이미 인증된 사용자가 로그인 페이지 접근 시 Select 페이지로 리다이렉트
  // if (isAuthenticated && to.name === 'Login') {
  //   next({ name: 'Select' })
  //   return
  // }

  next()
})

export default router
